import React, { useRef, useMemo } from "react";
import { DropdownContext } from "./Dropdown.context";
import { Collapse } from "../Collapse";
import DropdownFunctions from "./DropdownFunctions";
var Dropdown = function (_a) {
    var id = _a.id, children = _a.children;
    var refButton = useRef(undefined);
    var refContent = useRef(undefined);
    var contextValue = useMemo(function () { return ({
        refButton: refButton,
        refContent: refContent,
    }); }, [refButton, refContent]);
    return (React.createElement(DropdownContext.Provider, { value: contextValue },
        React.createElement(Collapse, { id: id },
            React.createElement(DropdownFunctions, null),
            children)));
};
export default Dropdown;
